import { graphql } from '@apollo/client/react/hoc';
import { flowRight as compose } from 'lodash';

import ViewAllNotificationsMutation from 'buyside/graphql/mutations/ViewAllNotifications';
import CurrentUserNotificationsQuery from 'buyside/graphql/queries/CurrentUserNotifications';

import NotificationsList from 'buyside/components/presentation/NotificationsIndex/NotificationsList/notificationsList';

const withData = graphql(CurrentUserNotificationsQuery, {
  options: ({ openTab }) => ({
    variables: { first: 15, filter: openTab },
    fetchPolicy: 'cache-and-network'
  }),
  props({ data }) {
    const { loading, error, currentUser, refetch, fetchMore } = data;
    return {
      loading,
      error,
      currentUser,
      refetch,
      loadMoreEntries: () => {
        return fetchMore({
          query: CurrentUserNotificationsQuery,
          variables: {
            cursor: currentUser.notifications.pageInfo.endCursor,
            first: 6
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const currentUser = fetchMoreResult.currentUser;
            const newEdges = fetchMoreResult.currentUser.notifications.edges;
            const pageInfo = fetchMoreResult.currentUser.notifications.pageInfo;
            return newEdges.length
              ? {
                  currentUser: {
                    id: currentUser.id,
                    __typename: previousResult.currentUser.__typename,
                    unreadNotificationsCount: currentUser.unreadNotificationsCount,
                    newNotificationsCount: currentUser.newNotificationsCount,
                    notifications: {
                      __typename: previousResult.currentUser.notifications.__typename,
                      edges: [...previousResult.currentUser.notifications.edges, ...newEdges],
                      pageInfo
                    }
                  }
                }
              : previousResult;
          }
        });
      }
    };
  }
});

const withMarkAllRead = graphql(ViewAllNotificationsMutation, {
  props: ({ mutate }) => ({
    viewAllNotifications: mutate
  })
});

const NotificationsListContainer = compose(withData, withMarkAllRead)(NotificationsList);

export default NotificationsListContainer;
